module.exports = __webpack_public_path__ + "img/9788991813274.2e2dc29a.jpg";